var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34625 13.4292L8.85544 11.9122L10.3708 13.4292L9.40388 14.3979C9.33192 14.47 9.24644 14.5272 9.15233 14.5663C9.05822 14.6054 8.95733 14.6255 8.85544 14.6255C8.75354 14.6255 8.65265 14.6054 8.55854 14.5663C8.46443 14.5272 8.37895 14.47 8.307 14.3979L7.34625 13.4292ZM11.2556 8.23061L9.74138 6.71355L11.2562 5.19649L12.7704 6.71355L11.2556 8.23061ZM10.8793 12.9348L9.3645 11.4177L13.4314 7.34411L14.3977 8.31217C14.7009 8.61592 14.7009 9.10698 14.3977 9.41073L10.8793 12.9348ZM6.71512 12.7784L5.20088 11.2614L9.261 7.19449L10.7753 8.71155L6.71512 12.7784ZM4.56525 10.6409L3.59831 9.6723C3.45391 9.5256 3.37359 9.32762 3.37496 9.12179C3.37633 8.91595 3.45928 8.71906 3.60562 8.5743L4.572 7.60567L6.08681 9.1233L4.56525 10.6409ZM10.6217 4.57267L6.55481 8.64405L5.04 7.12699L8.55844 3.60236C8.63039 3.53021 8.71587 3.47297 8.80998 3.43392C8.90409 3.39486 9.00498 3.37476 9.10688 3.37476C9.20877 3.37476 9.30966 3.39486 9.40377 3.43392C9.49788 3.47297 9.58336 3.53021 9.65531 3.60236L10.6217 4.57267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdo);
export default __webpack_public_path__ + "static/media/edo.6ec94ee752e8c3dd63e8f031bb4d991f.svg";
export { ForwardRef as ReactComponent };